import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'features.maintenance.title',
    defaultMessage: 'Manutenzione in corso',
    description: 'Maintenance page title',
  },
  description: {
    id: 'features.maintenance.description',
    defaultMessage:
      "Stiamo effettuando un intervento di manutenzione per offrirti un'esperienza sempre migliore.",
    description: 'Maintenance page description, below the title',
  },
  subtitle: {
    id: 'features.maintenance.subtitle',
    defaultMessage:
      "Il portale sarà nuovamente disponibile appena terminato l'intervento.",
    description: 'Maintenance page note on when the portal is back',
  },
});
